module.exports = __webpack_public_path__ + "static/media/MobileSellerboxFunction01.6431a2e4.png";